// Import-free on purpose: context/msgContext reaches colorthief and a native
// sharp build, which every importer would then pay for.
export const NOTIFICATION_QUERY_KEYS = [['patients-questionnaires'], ['unanswered-QnAs']];
